import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Divider, Grid } from '@mui/material';
import Icon from '@mui/material/Icon';
import React from 'react';

import Text from 'commons/Text';
import { TESTID } from 'configs/Constant';

import useStyles from './styles';

const CollectionList = ({ listCollection, onClickOpenDialogDelete, onClickOpenDialogEdit }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={3}
      rowSpacing={1}
    >
      {listCollection.map((item, index) => (
        <Grid
          key={index}
          item
          lg={12}
          xs={12}
        >
          <div className={classes.listItemPublication}>
            <div className={classes.wrapYearAward}>
              {item?.is_public ? (
                <VisibilityOutlinedIcon className={classes.iconVisibility} />
              ) : (
                <VisibilityOffOutlinedIcon className={classes.iconVisibility} />
              )}
              <Text className={classes.textYearAward}>{item?.name}</Text>
            </div>

            <div className={classes.wrapDescriptionAndIcon}>
              <Icon
                onClick={() => onClickOpenDialogEdit(item)}
                className={classes.editIcon}
                testid={TESTID.EDIT_ICON_PUBLICATION_LIST}
              >
                <EditOutlinedIcon />
              </Icon>
              <Icon
                onClick={() => onClickOpenDialogDelete(item)}
                testid={TESTID.CLOSE_ICON_PUBLICATION_LIST}
              >
                <CloseIcon />
              </Icon>
            </div>
          </div>

          <Divider className={classes.dividerStyle} />
        </Grid>
      ))}
    </Grid>
  );
};

export default CollectionList;
